// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1__cd5c48fcf9118575d546","cls2":"NewsInteractionBar-cls2___b79e62ea9336a175856 NewsInteractionBar-cls1__cd5c48fcf9118575d546"};